<template lang="pug">
v-form.authForm.py-4(v-model='valid' @submit.prevent="submit" ref="form" lazy-validation)
  v-text-field(v-model='submitData.email' filled rounded :label='$t("auth.forms.email")' type='email' prepend-inner-icon='mail_outline' :rules='[required, email]')
  v-text-field(v-model='submitData.currentPassword' filled rounded :label='$t("auth.forms.oldPassword")' :type="showOldPassword ? 'text' : 'password'" :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'" :rules='[required]' @click:append='showOldPassword = !showOldPassword')
  v-text-field(v-model='submitData.newPassword' :hint='$t("validations.password")' filled rounded :label='$t("auth.forms.newPassword")' :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :rules='[required, password]' @click:append='showPassword = !showPassword')
  v-text-field(v-model='repeatPassword' filled rounded :label='$t("auth.forms.repeatPassword")' :type="showPasswordRepeat ? 'text' : 'password'" :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'" :rules='[required, min, (submitData.newPassword === repeatPassword)]' @click:append='showPasswordRepeat = !showPasswordRepeat')

  v-row(justify="center")
    v-btn.my-5(large depressed='' :loading="loading", :disabled="loading || !valid" color='accent' type="submit") {{$t('auth.login')}}

</template>
<script>
import validations from "@/utils/validations";
import { mapState } from "vuex";
export default {
  props: ["submitForm", "bottomText"],
  data() {
    return {
      oldPassword: false,
      showPassword: false,
      showPasswordRepeat: false,
      showOldPassword: false,

      repeatPassword: "",
      submitData: {
        email: "",
        currentPassword: "",
        newPassword: "",
      },
      ...validations,
      valid: false,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.auth.loading,
    }),
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.submitForm(this.submitData);
      }
    },
  },
  created() {
    const email = this.$route.query.email;
    const password = this.$route.query.pw;
    if (email) this.submitData.email = email;
    if (password) this.submitData.currentPassword = password;
  },
};
</script>
